import React from 'react';
import { Dropdown } from 'react-bootstrap';

import './DropdownMenu.scss';

export interface IDropdownOption {
  id: string | number;
  label: string;
}

export interface IDropdownOptionLink extends IDropdownOption {
  onClick?: (e: React.MouseEvent<unknown>) => void;
}

export interface IDropdownMenuProps {
  className?: string;
  menuOnly?: boolean;
  options: IDropdownOptionLink[];
}

const DropdownMenu = ({ className, menuOnly = false, options }: IDropdownMenuProps) => {
  const renderMenu = () => (
    <Dropdown.Menu className={className} bsPrefix="DropdownMenu">
      {options.map((option: IDropdownOptionLink) => (
        <Dropdown.Item
          key={option.id}
          id={option.id}
          eventKey={option.id}
          onClick={option.onClick ?? undefined}
        >
          {option.label}
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  );

  return menuOnly ? (
    <Dropdown show>
      <Dropdown.Toggle className="DropdownMenu--hidden" />
      {renderMenu()}
    </Dropdown>
  ) : (
    renderMenu()
  );
};

DropdownMenu.defaultProps = {
  className: '',
  menuOnly: false,
};

export default DropdownMenu;
